// extracted by mini-css-extract-plugin
module.exports = {"container":"SendMessageTextArea_container__2h9zE"};